module.exports = __webpack_public_path__ + "static/img/MORARA.bb817e15.jpg";